//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../AME/AME.ObjectConnectionBuilder.js";
import "../AME/AME.ObjectConnectionDetailBuilder.js";
import "../AME/AME.SelectIPort.js";
import "../no/SelectObject.js";
let d=[[[0,"CurrentParameterRuleType",1,0],[1,"ObjectConnection",0,"AME.ObjectConnectionBuilder",0],[1,"ObjectConnectionDetail",0,"AME.ObjectConnectionDetailBuilder",0],[1,"ParameterObjectConnection",0,"AME.ObjectConnectionBuilder",0],[1,"ParameterSelectionPort",0,"AME.SelectIPort",0],[0,"ParameterSelectionType",1,0],[0,"ParameterText",1,0],[1,"SelectionPort",0,"AME.SelectIPort",0]],[[["paramOwnerId","paramName"],"UpdateSelectedParameter",{},2,0],[["paramOwnerId","paramName"],"RefreshContent",{},2,0]],[]];
SPLM.AME.PlcStateChartDefineCallBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.PlcStateChartDefineCallBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;